import React from 'react';
import {observable, action, computed, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';
import * as util from '../../../util';
import ModalSimple from '../../../global/modal-simple';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/scrollbar';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/zoom';
import {Keyboard, Scrollbar, Navigation, Zoom} from 'swiper/modules';
import ProductRender from '../../rendering/render';
import {r} from '../../rendering/core';
import * as emitter from '../../../global/emitter';
import AbTestStore, {ABTestKeys} from '../../../global/store/ab-test.store';

declare const window: any;
declare var __portal: IPortalSettings;

@observer
export default class SliderTH extends React.Component {
    @observable zoom_id: string = '';
    @observable slideCount: number = 6;

    constructor(props) {
        super(props);
        this.loadSwiper = this.loadSwiper.bind(this);
        this.loadSwiperZoom = this.loadSwiperZoom.bind(this);
        this.toggleZoom = this.toggleZoom.bind(this);
        makeObservable(this);

        this.getSlidesPerView();

        document.addEventListener('modal-closed', function (e: any) {
            if (e.detail === 'modal-prod-swiper-th') {
                s.ui.zoom_thumbnails = false;
            }
        });
    }

    abForceUpdate = async () => this.forceUpdate();

    componentDidMount() {
        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', this.abForceUpdate);
    }

    @computed get show_slider(): boolean {
        if (!s.ready || !s.prod) {
            return false;
        }

        if (s.prod.MouldingID < 1 && s.prod.Mat1_ID < 1 && s.prod.th1Disabled && s.prod.th2Disabled && s.prod.th3Disabled && s.prod.th4Disabled && s.prod.th5Disabled && s.prod.th6Disabled && s.prod.th7Disabled && s.prod.th8Disabled && s.prod.th9Disabled && s.prod.th10Disabled) {
            return false;
        }
        return true;
    }

    @computed get do_loop(): boolean {
        if (!s.ready) {
            return true;
        }

        let slideCount = 0;

        if (s.prod.CustomizationMethod !== 1) {
            slideCount++;
        }

        if (s.pcs.moulding_id > 0 && s.ui.moulding_has_zoom) {
            slideCount++;
        }

        if (s.pcs.mat1_id > 0) {
            slideCount++;
        }

        if (s.pcs.insignia_id > 0) {
            slideCount++;
        }

        if (s.prod.real_images_th && s.prod.real_images_th.length > 0) {
            slideCount += s.prod.real_images_th.length;
        }

        if (!s.prod.disableGlassUpgrades) {
            slideCount++;
        }

        if (this.show_smart_box) {
            slideCount++;
        }

        for (let i = 1; i <= 10; i++) {
            const key = `th${i}`;
            const disabledKey = `${key}Disabled`;

            if (!s.prod[disabledKey] && !util.isNullOrWhiteSpace(s.prod[key])) {
                slideCount++;
            }
        }

        if (slideCount <= 6) {
            return false;
        }

        return s.prod.CustomizationMethod >= 2;
    }

    @action getSlidesPerView(value: number = 0) {
        if (window.innerWidth < 340) {
            this.slideCount = 3;
        } else if (window.innerWidth < 400) {
            this.slideCount = 3 + value;
        } else if (window.innerWidth < 510) {
            this.slideCount = 4 + value;
        } else if (window.innerWidth < 580) {
            this.slideCount = 5 + value;
        } else {
            this.slideCount = 6 + value;
        }
    }

    @action
    loadSwiper = async (swiper: any) => {
        util.ariaPulse();
    };

    @action
    loadSwiperZoom = async (swiper: any) => {
        if (!util.isNullOrWhiteSpace(this.zoom_id)) {
            var ele = document.getElementById(this.zoom_id);
            var index = parseInt(ele?.attributes['data-swiper-slide-index'].value, 10);
            swiper.slideToLoop(index);

            setTimeout(function () {
                swiper.slideToLoop(index);
            }, 250);
            setTimeout(function () {
                swiper.slideToLoop(index);
            }, 1250);
        }
        this.zoom_id = '';
        util.ariaPulse();
    };

    @action
    toggleZoom = async (e: any) => {
        this.zoom_id = e;
        s.pcs.css_zoom = r.render(s.prod.orig_pcs, util.RenderType.Zoom);
        s.ui.zoom_thumbnails = true;
        util.modal('modal-prod-swiper-th');
    };

    @computed get hide_dynamic(): boolean {
        if (!s.ready) {
            return false;
        }

        if ([70214, 70215, 70244, 84054].includes(s.prod.ProductID) || ['391332'].includes(s.prod.ItemID)) {
            return true;
        }
        return false;
    }

    @computed get show_smart_box() {
        if (!s.ready) {
            return false;
        }
        if (!s.ui.allow_smartbox) {
            return false;
        }
        if (s.prod.Shipping_BoxID <= 3 && s.prod.IsFrame && !s.prod.ProductTypeDisplayName.toLowerCase().includes('Photo') && !this.hide_dynamic) {
            return true;
        }
        return false;
    }

    render() {
        if (!s.ready) {
            return;
        }
        if (!this.show_slider) {
            return;
        }

        return (
            <div>
                <Swiper
                    id="prod-swiper-th"
                    onInit={this.loadSwiper}
                    slidesPerView={this.slideCount}
                    centeredSlidesBounds={!this.do_loop}
                    centeredSlides={!this.do_loop}
                    centerInsufficientSlides={!this.do_loop}
                    grabCursor={this.do_loop}
                    zoom={false}
                    keyboard={{
                        enabled: this.do_loop,
                    }}
                    scrollbar={false}
                    navigation={this.do_loop}
                    height={75}
                    loop={this.do_loop}
                    pagination={false}
                    modules={[Keyboard, Scrollbar, Navigation, Zoom]}
                    aria-roledescription="carousel"
                    role="region"
                    aria-label="Product images"
                >
                    {s.prod.CustomizationMethod === 2 && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom('slide-prod')}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod');
                                }
                            }}
                            aria-label="Open larger product image"
                            tabIndex={0}
                            role="button"
                        >
                            <div style={{padding: '8px', border: '1px solid silver'}}>
                                {!s.pcs.is_caf && (
                                    <img
                                        alt="Product Image"
                                        width="67"
                                        height="67"
                                        src={
                                            s.prod.CustomizationMethod > 1
                                                ? `https://${s.Portal.IMGDomain}/i/${s.prod.ProductID}_220_250.png?MouldingID=${s.pcs.moulding_id}&PrimaryMatID=${s.pcs.mat1_id}&SecondaryMatID=${s.pcs.mat2_id > 0 ? s.pcs.mat2_id : 0}&InsigniaID=${s.pcs.insignia_id > 0 ? s.pcs.insignia_id : 0}&LinoID=${s.pcs.lino_id > 0 ? s.pcs.lino_id : 0}`
                                                : `${s.prod.Image_Thumb}`
                                        }
                                        className="prod-th"
                                    />
                                )}
                                {s.pcs.is_caf && (
                                    <img
                                        alt="Product Image"
                                        width="67"
                                        height="67"
                                        src={
                                            s.prod.CustomizationMethod > 1
                                                ? `https://${s.Portal.IMGDomain}/i/0_220_250_${s.prod.ProductID}_${s.pcs.moulding_id}_${s.pcs.mat1_id}_${s.pcs.mat2_id > 0 ? s.pcs.mat2_id : 0}_${s.pcs.insignia_id > 0 ? s.pcs.insignia_id : 0}_${s.prod.DocumentID}_${s.prod.ExtraEntityID}_0___0____0__11.000_0_8.500_0_0_0_0.png`
                                                : `${s.prod.Image_Thumb}`
                                        }
                                        className="prod-th"
                                    />
                                )}
                            </div>
                        </SwiperSlide>
                    )}

                    {s.PortalID !== 3 && s.pcs.moulding_id > 0 && s.ui.moulding_has_zoom && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom('slide-prod-moulding')}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-moulding');
                                }
                            }}
                            aria-label={s.ui.moulding_th5 ? 'Open corner view of moulding' : 'Open larger image of moulding'}
                            tabIndex={0}
                            role="button"
                        >
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={s.ui.moulding_th5 ? `https://${s.Portal.CDNDomain}/images/entities/moulding/${s.pcs.moulding_id}_th5_75.webp` : util.webp(`https://${s.Portal.CDNDomain}/images/entities/moulding/${s.ui.moulding_zoom_path_th}`)}
                                />
                                <img
                                    alt="Moulding Image"
                                    src={`https://${s.Portal.CDNDomain}/images/entities/moulding/${s.ui.moulding_th5 ? `${s.pcs.moulding_id}_th5_75.png` : s.ui.moulding_zoom_path_th}`}
                                    height={75}
                                    width="75"
                                />
                            </picture>
                        </SwiperSlide>
                    )}

                    {s.PortalID !== 3 && s.pcs.moulding_id > 0 && s.ui.moulding_th6 && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom('slide-prod-moulding-2')}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-moulding-2');
                                }
                            }}
                            aria-label="Open profile view of moulding"
                            tabIndex={0}
                            role="button"
                        >
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={`https://${s.Portal.CDNDomain}/images/entities/moulding/${s.pcs.moulding_id}_th6_75.webp`}
                                />
                                <img
                                    alt="Moulding Profile Image"
                                    src={`https://${s.Portal.CDNDomain}/images/entities/moulding/${s.pcs.moulding_id}_th6_75.png`}
                                    height={75}
                                    width="75"
                                />
                            </picture>
                        </SwiperSlide>
                    )}

                    {s.PortalID !== 3 && s.prod && s.prod.is_tassel_cord && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom('slide-prod-tassel-cord')}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-tassel-cord');
                                }
                            }}
                            aria-label="Open larger image of tassel cord thumbnail"
                            id=""
                            tabIndex={0}
                            role="button"
                        >
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/tassel-cord-th.webp`}
                                />
                                <img
                                    src={`https://${s.Portal.CDNDomain}/images/cached/general/tassel-cord-th.png`}
                                    height={75}
                                    width="75"
                                    alt={`Tassel & Cord Frame holds ${s.si.ProdInstText} graduation tassel or honor cords`}
                                />
                            </picture>
                        </SwiperSlide>
                    )}

                    {(s.prod.ProductTypeID == 83 || s.prod.ProductTypeID == 84 || s.prod.ProductTypeID == 87) && s.PortalID !== 3 && !util.isNullOrWhiteSpace(s.prod.th_auto_2_16) && s.prod.th_auto_2_16 && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th_auto_2_16`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th_auto_2_16');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #16`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={s.prod.th_auto_2_16.replace('.png', '.webp').replace('.jpg', '.webp')}
                                    />
                                    <img
                                        src={s.prod.th_auto_2_16}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #16`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}

                    {(s.prod.ProductTypeID == 83 || s.prod.ProductTypeID == 84 || s.prod.ProductTypeID == 87) && s.PortalID !== 3 && !util.isNullOrWhiteSpace(s.prod.th_auto_2_17) && s.prod.th_auto_2_17 && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th_auto_2_17`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th_auto_2_17');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #17`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={s.prod.th_auto_2_17.replace('.png', '.webp').replace('.jpg', '.webp')}
                                    />
                                    <img
                                        src={s.prod.th_auto_2_17}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #17`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}

                    {!s.prod.th5Disabled && s.PortalID !== 3 && !util.isNullOrWhiteSpace(s.prod.th5) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th5`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th5');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #5`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th5}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th5}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #5`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}
                    {!s.prod.th6Disabled && s.PortalID !== 3 && !util.isNullOrWhiteSpace(s.prod.th6) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th6`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th6');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #6`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th6}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th6}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #6`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}
                    {!s.prod.th1Disabled && !util.isNullOrWhiteSpace(s.prod.th1) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th1`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th1');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #1`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th1}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th1}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #1`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}
                    {!s.prod.th2Disabled && !util.isNullOrWhiteSpace(s.prod.th2) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th2`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th2');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #2`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th2}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th2}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #2`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}
                    {!s.prod.th3Disabled && !util.isNullOrWhiteSpace(s.prod.th3) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th3`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th3');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #3`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th3}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th3}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #3`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}
                    {!s.prod.th4Disabled && !util.isNullOrWhiteSpace(s.prod.th4) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th4`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th4');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #4`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th4}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th4}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #4`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}
                    {!s.prod.th7Disabled && !util.isNullOrWhiteSpace(s.prod.th7) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th7`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th7');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #7`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th7}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th7}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #7`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}
                    {!s.prod.th8Disabled && !util.isNullOrWhiteSpace(s.prod.th8) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th8`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th8');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #8`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th8}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th8}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #8`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}
                    {!s.prod.th9Disabled && !util.isNullOrWhiteSpace(s.prod.th9) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th9`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th9');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #9`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th9}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th9}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #9`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}
                    {!s.prod.th10Disabled && s.prod.CustomizationMethod === 2 && !util.isNullOrWhiteSpace(s.prod.th10) && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom(`slide-prod-th10`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-th10');
                                }
                            }}
                            aria-label={`Open larger image of product thumbnail #10`}
                            tabIndex={0}
                        >
                            <div style={{border: '1px solid silver'}}>
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${s.prod.th10}_75.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}${s.prod.th10}_75.jpg`}
                                        height={s.product_thumbnail_height}
                                        alt={`Product thumbnail #10`}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}

                    {s.pcs.mat1_id > 0 && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom('slide-prod-matcombo')}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-matcombo');
                                }
                            }}
                            aria-label="Open larger image of mats"
                            tabIndex={0}
                            role="button"
                        >
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={`https://${s.Portal.CDNDomain}/images/entities/matcombos/75_${s.pcs.mat1_id}${s.pcs.mat2_id > 0 ? `_${s.pcs.mat2_id.toString()}` : ''}.webp`}
                                />
                                <img
                                    src={`https://${s.Portal.CDNDomain}/images/entities/matcombos/75_${s.pcs.mat1_id}${s.pcs.mat2_id > 0 ? `_${s.pcs.mat2_id.toString()}` : ''}.png`}
                                    height="75"
                                    width="75"
                                    alt={s.ui.title_mat_combo}
                                    style={{
                                        maxWidth: window.innerWidth * 0.8,
                                        maxHeight: window.innerHeight * 0.8,
                                    }}
                                />
                            </picture>
                        </SwiperSlide>
                    )}

                    {s.pcs.insignia_id > 0 && (
                        <SwiperSlide
                            onClick={() => this.toggleZoom('slide-prod-ins')}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-ins');
                                }
                            }}
                            aria-label="Open larger image of insignia"
                            tabIndex={0}
                            role="button"
                        >
                            <div
                                className="ins"
                                style={{
                                    backgroundImage: `image-set(url('https://${s.Portal.CDNDomain}/images/entities/primarymat/v2/${s.ui.name_mat1}_320.webp') type('image/webp') 1x, url('https://${s.Portal.CDNDomain}/images/entities/primarymat/v2/${s.ui.name_mat1}_320.jpg') type('image/jpeg') 1x)`,
                                }}
                            >
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}/images/entities/insignia/v2/${s.ui.name_insignia.toLowerCase()}_90.webp`}
                                    />
                                    <img
                                        src={`https://${s.Portal.CDNDomain}/images/entities/insignia/v2/${s.ui.name_insignia.toLowerCase()}_90.png`}
                                        height={71}
                                        width={71}
                                        alt={s.ui.title_insignia}
                                    />
                                </picture>
                            </div>
                        </SwiperSlide>
                    )}

                    {s.prod.real_images_th.map(m => (
                        <SwiperSlide
                            key={m.id}
                            onClick={() => this.toggleZoom(`slide-prod-real-${m.id}`)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom(`slide-prod-real-${m.id}`);
                                }
                            }}
                            aria-label="Open larger image of this real life image"
                            tabIndex={0}
                            role="button"
                        >
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={`https://${s.Portal.CDNDomain}/images/cached/rp/rp${m.id}_th250.webp`}
                                />
                                <img
                                    alt="Real Life Image #1"
                                    src={`https://${s.Portal.CDNDomain}/images/cached/rp/rp${m.id}_th250.jpg`}
                                    height={75}
                                    width="75"
                                />
                            </picture>
                        </SwiperSlide>
                    ))}

                    {s.prod.CustomizationMethod !== 2 && s.prod.OldInsigniaThumb && s.prod.OldInsigniaThumb != '' && (
                        <SwiperSlide
                            key={43}
                            onClick={() => this.toggleZoom('slide-prod-old-ins')}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-old-ins');
                                }
                            }}
                            aria-label="Open larger image of insignia"
                            tabIndex={0}
                            role="button"
                        >
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={util.webp(`https://${s.Portal.CDNDomain}/images/products/insignia/thumb/${s.prod.OldInsigniaThumb.toLowerCase()}`)}
                                />
                                <img
                                    src={`https://${s.Portal.CDNDomain}/images/products/insignia/thumb/${s.prod.OldInsigniaThumb.toLowerCase()}`}
                                    height={75}
                                    width="75"
                                    alt="Insignia"
                                    style={{
                                        maxWidth: window.innerWidth * 0.8,
                                        maxHeight: window.innerHeight * 0.8,
                                    }}
                                />
                            </picture>
                        </SwiperSlide>
                    )}

                    {this.show_smart_box && (
                        <SwiperSlide
                            key={42}
                            onClick={() => this.toggleZoom('slide-prod-smartbox')}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-smartbox');
                                }
                            }}
                            aria-label="Open larger image of smartbox packaging"
                            tabIndex={0}
                            role="button"
                        >
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/smartbox_75.webp`}
                                />
                                <img
                                    src={`https://${s.Portal.CDNDomain}/images/cached/general/smartbox_75.jpg`}
                                    height={75}
                                    width="75"
                                    alt="SMARTbox Packaging"
                                />
                            </picture>
                        </SwiperSlide>
                    )}

                    {!AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) && s.prod && s.prod.IsFrame && s.prod.ProductID !== 84054 && s.prod.ProductID !== 70214 && !s.prod.disableGlassUpgrades && (
                        <SwiperSlide
                            key={43}
                            onClick={() => this.toggleZoom('slide-prod-glassoptions')}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleZoom('slide-prod-glassoptions');
                                }
                            }}
                            aria-label="Open larger image of glass options"
                            tabIndex={0}
                            role="button"
                        >
                            <picture>
                                {s.prod.AllowGlassID2 > 0 && (
                                    <source
                                        type="image/webp"
                                        data-srcset="https://${s.Portal.CDNDomain}/images/cached/general/glass-all-75.webp"
                                    />
                                )}
                                {s.prod.AllowGlassID2 > 0 && (
                                    <img
                                        src={`https://${s.Portal.CDNDomain}/images/cached/general/glass-all-75.png`}
                                        alt="Glass Options"
                                        style={{
                                            maxWidth: window.innerWidth * 0.8,
                                            maxHeight: window.innerHeight * 0.8,
                                        }}
                                    />
                                )}

                                {(!s.prod.AllowGlassID2 || s.prod.AllowGlassID2 < 1) && (
                                    <source
                                        type="image/webp"
                                        data-srcset="https://${s.Portal.CDNDomain}/images/cached/general/glass-46-th.webp"
                                    />
                                )}
                                {(!s.prod.AllowGlassID2 || s.prod.AllowGlassID2 < 1) && (
                                    <img
                                        src={`https://${s.Portal.CDNDomain}/images/cached/general/glass-46-th.jpg`}
                                        alt="Glass Options"
                                        style={{
                                            maxWidth: window.innerWidth * 0.8,
                                            maxHeight: window.innerHeight * 0.8,
                                        }}
                                    />
                                )}
                            </picture>
                        </SwiperSlide>
                    )}
                </Swiper>
                {s.ui.zoom_thumbnails && (
                    <ModalSimple
                        id="modal-prod-swiper-th"
                        title="Product Zoom"
                        open={true}
                        maxWidth={'90%'}
                        close={() => (s.ui.zoom_thumbnails = false)}
                    >
                        <Swiper
                            id="prod-swiper-th-zoom"
                            onInit={this.loadSwiperZoom}
                            slidesPerView={1}
                            centeredSlides={true}
                            grabCursor={true}
                            zoom={true}
                            keyboard={{enabled: true}}
                            loop={true}
                            scrollbar={true}
                            navigation={true}
                            pagination={false}
                            modules={[Keyboard, Scrollbar, Navigation, Zoom]}
                            slidesPerGroupAuto={true}
                            aria-roledescription="carousel"
                            role="region"
                            aria-label="Product images"
                        >
                            {s.prod.CustomizationMethod === 2 && (
                                <SwiperSlide id="slide-prod">
                                    <ProductRender
                                        zoom={true}
                                        css={s.pcs.css_zoom}
                                    />
                                </SwiperSlide>
                            )}

                            {s.pcs.moulding_id > 0 && (
                                <SwiperSlide id="slide-prod-moulding">
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/entities/moulding/${s.ui.moulding_th5 ? `${s.pcs.moulding_id}_th5.webp` : s.ui.moulding_zoom_path.toLowerCase().replace('.png', '.webp')}`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/entities/moulding/${s.ui.moulding_th5 ? `${s.pcs.moulding_id}_th5.png` : s.ui.moulding_zoom_path.toLowerCase()}`}
                                            alt={s.ui.title_moulding}
                                            onClick={this.toggleZoom}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                        />
                                    </picture>
                                </SwiperSlide>
                            )}

                            {s.ui.moulding_th6 && (
                                <SwiperSlide id="slide-prod-moulding-2">
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/entities/moulding/${s.pcs.moulding_id}_th6.webp`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/entities/moulding/${s.pcs.moulding_id}_th6.png`}
                                            alt={s.ui.title_moulding}
                                            onClick={this.toggleZoom}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                        />
                                    </picture>
                                </SwiperSlide>
                            )}

                            {s.prod && s.prod.is_tassel_cord && (
                                <SwiperSlide id="slide-prod-tassel-cord">
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/tassel-cord-2-way.webp`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/cached/general/tassel-cord-2-way.png`}
                                            alt={`Tassel & Cord Frame holds ${s.si.ProdInstText} graduation tassel or honor cords`}
                                            onClick={this.toggleZoom}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                        />
                                    </picture>
                                </SwiperSlide>
                            )}

                            {(s.prod.ProductTypeID == 83 || s.prod.ProductTypeID == 84 || s.prod.ProductTypeID == 87) && !util.isNullOrWhiteSpace(s.prod.th_auto_2_16) && (
                                <SwiperSlide id={`slide-prod-th_auto_2_16`}>
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={s.prod.th_auto_2_16.replace('.png', '.webp').replace('.jpg', '.webp')}
                                        />
                                        <img
                                            src={s.prod.th_auto_2_16}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #16`}
                                        />
                                    </picture>

                                    <div className="swiper-zoom-container"></div>
                                </SwiperSlide>
                            )}

                            {(s.prod.ProductTypeID == 83 || s.prod.ProductTypeID == 84 || s.prod.ProductTypeID == 87) && !util.isNullOrWhiteSpace(s.prod.th_auto_2_17) && (
                                <SwiperSlide id={`slide-prod-th_auto_2_17`}>
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={s.prod.th_auto_2_17.replace('.png', '.webp').replace('.jpg', '.webp')}
                                        />
                                        <img
                                            src={s.prod.th_auto_2_17}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #17`}
                                        />
                                    </picture>

                                    <div className="swiper-zoom-container"></div>
                                </SwiperSlide>
                            )}

                            {!s.prod.th5Disabled && !util.isNullOrWhiteSpace(s.prod.th5) && (
                                <SwiperSlide id={`slide-prod-th5`}>
                                    {!s.prod.th5_special && <div className="zoom-overlay">Photo represents scale dimensions only (final art/colors may differ)</div>}
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={s.prod.th5_special ? `https://${s.Portal.CDNDomain}${s.si.th_auto_2_2}` : `https://${s.Portal.CDNDomain}${s.prod.th5}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #5`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                            {!s.prod.th6Disabled && !util.isNullOrWhiteSpace(s.prod.th6) && (
                                <SwiperSlide id={`slide-prod-th6`}>
                                    {!s.prod.th6_special && <div className="zoom-overlay">Photo represents scale dimensions only (final art/colors may differ)</div>}
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={s.prod.th6_special ? `https://${s.Portal.CDNDomain}${s.si.th_auto_2_1}` : `https://${s.Portal.CDNDomain}${s.prod.th6}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #6`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                            {!s.prod.th1Disabled && !util.isNullOrWhiteSpace(s.prod.th1) && (
                                <SwiperSlide id={`slide-prod-th1`}>
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={`https://${s.Portal.CDNDomain}${s.prod.th1}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #1`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                            {!s.prod.th2Disabled && !util.isNullOrWhiteSpace(s.prod.th2) && (
                                <SwiperSlide id={`slide-prod-th2`}>
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={`https://${s.Portal.CDNDomain}${s.prod.th2}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #2`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                            {!s.prod.th3Disabled && !util.isNullOrWhiteSpace(s.prod.th3) && (
                                <SwiperSlide id={`slide-prod-th3`}>
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={`https://${s.Portal.CDNDomain}${s.prod.th3}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #3`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                            {!s.prod.th4Disabled && !util.isNullOrWhiteSpace(s.prod.th4) && (
                                <SwiperSlide id={`slide-prod-th4`}>
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={`https://${s.Portal.CDNDomain}${s.prod.th4}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #4`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                            {!s.prod.th7Disabled && !util.isNullOrWhiteSpace(s.prod.th7) && (
                                <SwiperSlide id={`slide-prod-th7`}>
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={`https://${s.Portal.CDNDomain}${s.prod.th7}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #7`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                            {!s.prod.th8Disabled && !util.isNullOrWhiteSpace(s.prod.th8) && (
                                <SwiperSlide id={`slide-prod-th8`}>
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={`https://${s.Portal.CDNDomain}${s.prod.th8}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #8`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                            {!s.prod.th9Disabled && !util.isNullOrWhiteSpace(s.prod.th9) && (
                                <SwiperSlide id={`slide-prod-th9`}>
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={`https://${s.Portal.CDNDomain}${s.prod.th9}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #9`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}
                            {!s.prod.th10Disabled && s.prod.CustomizationMethod === 2 && !util.isNullOrWhiteSpace(s.prod.th10) && (
                                <SwiperSlide id={`slide-prod-th10`}>
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={`https://${s.Portal.CDNDomain}${s.prod.th10}_1440.jpg`}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            alt={`Product thumbnail zoom #10`}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}

                            {s.pcs.mat1_id > 0 && (
                                <SwiperSlide id="slide-prod-matcombo">
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/entities/matcombos/1024_${s.pcs.mat1_id}${s.pcs.mat2_id > 0 ? `_${s.pcs.mat2_id.toString()}` : ''}.webp`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/entities/matcombos/1024_${s.pcs.mat1_id}${s.pcs.mat2_id > 0 ? `_${s.pcs.mat2_id.toString()}` : ''}.png`}
                                            alt={s.ui.title_mat_combo}
                                            onClick={this.toggleZoom}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                        />
                                    </picture>
                                </SwiperSlide>
                            )}

                            {s.pcs.insignia_id > 0 && (
                                <SwiperSlide id="slide-prod-ins">
                                    <div
                                        style={{
                                            backgroundColor: `#${s.ui.color_mat1}`,
                                            backgroundRepeat: 'repeat',
                                        }}
                                    >
                                        <picture className="swiper-zoom-container">
                                            <source
                                                type="image/webp"
                                                srcSet={`https://${s.Portal.CDNDomain}/images/entities/insignia/v2/${s.ui.name_insignia.toLowerCase()}_original.webp`}
                                            />
                                            <img
                                                src={`https://${s.Portal.CDNDomain}/images/entities/insignia/v2/${s.ui.name_insignia.toLowerCase()}_original.png`}
                                                style={{
                                                    maxWidth: window.innerWidth * 0.8,
                                                    maxHeight: window.innerHeight * 0.8,
                                                }}
                                                alt={'Open larger image of insignia'}
                                                onClick={this.toggleZoom}
                                            />
                                        </picture>
                                    </div>
                                </SwiperSlide>
                            )}

                            {s.prod.real_images_th.map(m => (
                                <SwiperSlide
                                    key={m.id}
                                    id={`slide-prod-real-${m.id}`}
                                >
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/cached/rp/rp${m.id}_th1024.webp`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/cached/rp/rp${m.id}_th1024.jpg`}
                                            alt="Real Image #1"
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            onClick={this.toggleZoom}
                                        />
                                    </picture>
                                </SwiperSlide>
                            ))}

                            {s.prod.CustomizationMethod !== 2 && s.prod.OldInsigniaThumb && s.prod.OldInsigniaThumb != '' && (
                                <SwiperSlide
                                    key={43}
                                    id="slide-prod-old-ins"
                                >
                                    <div className="swiper-zoom-container">
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/products/insignia/full/${s.prod.OldInsigniaImage.toLowerCase()}`}
                                            alt="Insignia"
                                            onClick={this.toggleZoom}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                                minWidth: '50%',
                                            }}
                                        />
                                    </div>
                                </SwiperSlide>
                            )}

                            {this.show_smart_box && (
                                <SwiperSlide
                                    key={42}
                                    id="slide-prod-smartbox"
                                >
                                    <div className="zoom-overlay">Photo represents our protective SMARTbox packaging (actual frame may differ)</div>
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/smartbox_1024.webp`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}/images/cached/general/smartbox_1024.jpg`}
                                            alt="SMARTbox Packaging"
                                            onClick={this.toggleZoom}
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                        />
                                    </picture>
                                </SwiperSlide>
                            )}

                            {!AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) && s.prod && s.prod.IsFrame && s.prod.ProductID !== 84054 && s.prod.ProductID !== 70214 && !s.prod.disableGlassUpgrades && (
                                <SwiperSlide
                                    key={43}
                                    id="slide-prod-glassoptions"
                                >
                                    {s.prod.AllowGlassID2 > 0 && (
                                        <picture className="swiper-zoom-container">
                                            <source
                                                type="image/webp"
                                                srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/glass-all.webp`}
                                            />
                                            <img
                                                src={`https://${s.Portal.CDNDomain}/images/cached/general/glass-all.png`}
                                                alt="Glass Options"
                                                onClick={this.toggleZoom}
                                                style={{
                                                    maxWidth: window.innerWidth * 0.8,
                                                    maxHeight: window.innerHeight * 0.8,
                                                }}
                                            />
                                        </picture>
                                    )}
                                    {(!s.prod.AllowGlassID2 || s.prod.AllowGlassID2 < 1) && (
                                        <picture className="swiper-zoom-container">
                                            <source
                                                type="image/webp"
                                                srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/glass-46.webp`}
                                            />
                                            <img
                                                src={`https://${s.Portal.CDNDomain}/images/cached/general/glass-46.jpg`}
                                                alt="Glass Options"
                                                onClick={this.toggleZoom}
                                                style={{
                                                    maxWidth: window.innerWidth * 0.8,
                                                    maxHeight: window.innerHeight * 0.8,
                                                }}
                                            />
                                        </picture>
                                    )}
                                </SwiperSlide>
                            )}
                        </Swiper>
                    </ModalSimple>
                )}
            </div>
        );
    }
}
